import * as yup from 'yup'

const rublePattern = /^\d+(?:[.,]\d{1,2})?$/
const limitedRublePattern = /^\d{1,9}(?:[.,]\d{1,2})?$/
const invalidPriceMessage = 'Укажите цену в рублях с точностью не более двух знаков после запятой'
const priceLimitMessage = 'Цена должна быть меньше 1 000 000 000 ₽'

export type OfferFormValues = {
  comment: string
  price: string
}

export const offerFormSchema: yup.ObjectSchema<OfferFormValues> = yup.object({
  comment: yup.string().trim().max(2000, 'Предложение должно содержать не более 2000 символов').defined(),
  price: yup
    .string()
    .trim()
    .test('rubles', invalidPriceMessage, (value) => !value || rublePattern.test(value))
    .test(
      'rubles-limit',
      priceLimitMessage,
      (value) => !value || !rublePattern.test(value) || limitedRublePattern.test(value)
    )
    .defined(),
})

/**
 * На экране цена остаётся в рублях, а договор ручки использует целые копейки.
 */
export const kopecksFromRubles = (rubles: string) => {
  const normalizedRubles = rubles.trim().replace(',', '.')
  if (!limitedRublePattern.test(normalizedRubles)) {
    return null
  }

  const [wholeRubles, fractionalKopecks = ''] = normalizedRubles.split('.')
  const amount = Number(wholeRubles) * 100 + Number(fractionalKopecks.padEnd(2, '0'))

  return Number.isSafeInteger(amount) && amount > 0 ? amount : null
}
